import React from 'react';
import Checkbox from './Checkbox/Checkbox';
import { useTranslation } from 'react-i18next';

export type MarketingPreferenceOptions = {
  doNotContact: boolean;
};

export type MarketingPreferencesProps = {
  options: MarketingPreferenceOptions;
  setDoNotContact: (doNotContact: boolean) => void;
  disclaimer: string;
};

const MarketingPreferences = ({
  options,
  setDoNotContact,
  disclaimer
}: MarketingPreferencesProps): JSX.Element => {
  const { t } = useTranslation();

  const onDoNotContactChange = () => {
    setDoNotContact(!options.doNotContact);
  };

  return (
    <>
      <div className='control-label'>{disclaimer}</div>
      <div className='m05-top'>
        <Checkbox
          id='do-not-contact'
          checked={options.doNotContact}
          text={t(
            'customer-product-page.save-quote-confirmation.do-not-contact'
          )}
          onChange={onDoNotContactChange}
        />
      </div>
    </>
  );
};

export default MarketingPreferences;
